import { defineTracking } from 'services/google-analytics';

const category = 'new landing page - why join banner';

export default {
  ...defineTracking({
    nextCard: {
      category,
      action: 'click',
      label: 'next card button',
      description: 'This event is triggered when a user clicks the next card button.',
    },
    previousCard: {
      category,
      action: 'click',
      label: 'previous card button',
      description: 'This event is triggered when a user clicks the previous card button.',
    },
    sliderDotNav: {
      category,
      action: 'click',
      label: 'slider dot nav button',
      description: 'This event is triggered when a user clicks to navigate cards via slider dots.',
    },
    mobileCardSwipeNav: {
      category,
      action: 'swipe',
      label: '{direction} mobile card swipe',
      description:
        'This event is triggered when a user swipes to navigate cards via mobile card carousel. ' +
        '{direction} represents the direction the user swiped.',
    },
  }),
};
